<script lang="ts">
  // Right promotional sidebar for desktop (Library, Settings, Profile pages)
</script>

<!-- Right Promo Sidebar - Desktop only -->
<aside class="w-80 bg-gray-50 dark:bg-gray-900 border-l dark:border-gray-700 flex-shrink-0 overflow-y-auto">
  <div class="p-6 space-y-6">
    <!-- Promo Section 1: Featured Book -->
    <div class="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm">
      <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">
        Featured Book
      </h3>
      <div class="space-y-2">
        <div class="aspect-[2/3] bg-gradient-to-br from-blue-500 to-purple-600 rounded"></div>
        <p class="text-xs text-gray-600 dark:text-gray-400 line-clamp-2">
          Discover the latest bestseller in our collection
        </p>
        <button class="w-full px-3 py-2 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors">
          Read Now
        </button>
      </div>
    </div>

    <!-- Promo Section 2: Statistics -->
    <div class="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm">
      <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">
        Your Reading Stats
      </h3>
      <div class="space-y-3">
        <div class="flex justify-between items-center">
          <span class="text-xs text-gray-600 dark:text-gray-400">Books Read</span>
          <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">12</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-xs text-gray-600 dark:text-gray-400">Reading Time</span>
          <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">48h</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-xs text-gray-600 dark:text-gray-400">Current Streak</span>
          <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">7 days</span>
        </div>
      </div>
    </div>

    <!-- Promo Section 3: Community -->
    <div class="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm">
      <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">
        Join Community
      </h3>
      <p class="text-xs text-gray-600 dark:text-gray-400 mb-3">
        Connect with other readers and share your favorite books
      </p>
      <div class="flex gap-2">
        <button class="flex-1 px-3 py-2 text-xs font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors">
          Forum
        </button>
        <button class="flex-1 px-3 py-2 text-xs font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors">
          Chat
        </button>
      </div>
    </div>

    <!-- Promo Section 4: Recommendations -->
    <div class="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm">
      <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">
        Recommended
      </h3>
      <div class="space-y-2">
        <div class="flex gap-2">
          <div class="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-600 rounded flex-shrink-0"></div>
          <div class="flex-1 min-w-0">
            <p class="text-xs font-medium text-gray-900 dark:text-gray-100 truncate">Book Title 1</p>
            <p class="text-xs text-gray-500 dark:text-gray-400 truncate">Author Name</p>
          </div>
        </div>
        <div class="flex gap-2">
          <div class="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded flex-shrink-0"></div>
          <div class="flex-1 min-w-0">
            <p class="text-xs font-medium text-gray-900 dark:text-gray-100 truncate">Book Title 2</p>
            <p class="text-xs text-gray-500 dark:text-gray-400 truncate">Author Name</p>
          </div>
        </div>
        <div class="flex gap-2">
          <div class="w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-600 rounded flex-shrink-0"></div>
          <div class="flex-1 min-w-0">
            <p class="text-xs font-medium text-gray-900 dark:text-gray-100 truncate">Book Title 3</p>
            <p class="text-xs text-gray-500 dark:text-gray-400 truncate">Author Name</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Promo Section 5: Premium -->
    <div class="bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg p-4 shadow-sm text-white">
      <h3 class="text-sm font-semibold mb-2">
        Upgrade to Premium
      </h3>
      <p class="text-xs opacity-90 mb-3">
        Unlock unlimited books and advanced features
      </p>
      <button class="w-full px-3 py-2 text-xs font-medium text-blue-600 bg-white hover:bg-gray-100 rounded-lg transition-colors">
        Learn More
      </button>
    </div>
  </div>
</aside>
